module.exports = __webpack_public_path__ + "img/gda.69948ad.png";